import React from 'react';
import Box from '@mui/material/Box';
import { chartColours } from '../../../core/constants/colours.constants';
import { RankingItem } from '../../../core/types/common.types';
import DonutChart from '../DonutChart';

interface DonutGridProps {
  items: RankingItem[];
}

function DonutGrid({ items }: DonutGridProps) {
  return (
    <Box
      sx={{
        display: 'grid',
        gap: 2,
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'repeat(2, minmax(0, 1fr))',
          md: 'repeat(3, minmax(0, 1fr))',
          lg: 'repeat(5, minmax(0, 1fr))',
        },
      }}
    >
      {items.map((item, index) => {
        const colour = chartColours[index % chartColours.length];

        return <DonutChart key={item.label} item={item} color={colour} backgroundColor={`${colour}26`} />;
      })}
    </Box>
  );
}

export default DonutGrid;
